import { useState, useEffect } from "react";
import { buscarEmpreendimentosService } from "../../../services/buscarEmpreendimentosService";
import { Empreendimento } from "../../../interfaces/Empreendimento";
// --------------------- Import Services ---------------------
export const useEmpreendimento = () => {
  const [empreendimento, setEmpreendimento] = useState<Empreendimento[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as empreendimento
  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true);
      try {
        const data = await buscarEmpreendimentosService();
        if (data) {
          setEmpreendimento(data);
        } else {
          console.error("Dados não encontrados");
        }
      } catch (error) {
        console.error("Erro ao buscar empreendimento:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, []);

  return { empreendimento, isLoading };
};
